import { useNavigate } from 'react-router-dom';

import { authService } from '../services/authService';
import { useAuthStore } from '../stores/authStore';
import { AUTH_ROUTES } from '../routes';

export function useAuth() {
  const navigate = useNavigate();
  const currentUser = useAuthStore((s) => s.currentUser);
  const isInitializing = useAuthStore((s) => s.isInitializing);
  const setCurrentUser = useAuthStore((s) => s.setCurrentUser);

  async function signOut(): Promise<void> {
    await authService.signOut();
    setCurrentUser(null);
    navigate(AUTH_ROUTES.LOGIN, { replace: true });
  }

  return {
    currentUser,
    isAuthenticated: currentUser !== null,
    isInitializing,
    signOut,
  };
}
